// extracted by mini-css-extract-plugin
module.exports = {"Widget":"Widget--2dECE","Last":"Last--2MDzZ"};